import isEqual from 'lodash/isEqual'
import { useFieldContext } from '../FieldContext'
import { useFieldOperatorChange } from './useFieldOperatorChange'
import { useFieldQrScan } from './useFieldQrScan'
import { useFieldRefs } from './useFieldRefs'
import { useFieldResolveFilterQuery } from './useFieldResolveFilterQuery'

export const useField = () => {
  const {
    filterField: props,
    fieldLayout,
    fieldValues,
    handleChange,
    changedFilteractionData,
    enableQRCodeReader
  } = useFieldContext()

  const { inputRef, parentRef } = useFieldRefs()

  const { qr, onScanSuccess } = useFieldQrScan({
    inputRef,
    parentRef,
    enableQRCodeReader
  })
  const { onChangeOperator } = useFieldOperatorChange({
    name: props?.name,
    fieldData: props?.name ? fieldValues[props.name] : undefined,
    handleChange
  })

  const { onResolveFilterQuery } = useFieldResolveFilterQuery({
    name: props?.name,
    fieldValues,
    handleChange
  })

  if (!props?.type || !props?.name || !Object.keys(fieldValues).length) {
    return { ready: false as const }
  }

  const { uuid, name, objectclassUuid = '' } = props

  const fieldData = fieldValues[name]

  const isFilteractionValue = isEqual(changedFilteractionData, fieldData)

  const currentOperator = fieldValues[name]?.operator || ''

  return {
    ready: true as const,
    refs: {
      inputRef,
      parentRef
    },
    handlers: {
      onChangeOperator,
      onResolveFilterQuery,
      onScanSuccess
    },
    qr,
    field: {
      filterField: props,
      fieldData,
      name,
      uuid,
      objectclassUuid,
      fieldLayout,
      currentOperator,
      isFilteractionValue,
      fieldValues
    }
  }
}

export type FieldReadyModel = Extract<
  ReturnType<typeof useField>,
  { ready: true }
>
